import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../app/app.store';
import { selectAuth, userLoggedOut } from '../app/features/auth/auth.slice';

export default function useAuth() {
  const dispatch = useAppDispatch();
  const auth = useAppSelector(selectAuth);

  const logout = useCallback(() => {
    dispatch(userLoggedOut());
    localStorage.clear();
  }, [dispatch]);

  return { ...auth, logout };
}
